<template>
  <div>
    <keep-alive>
    <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      operState: 0, // 判断是新增还是编辑的数据回显
      currentLine: {}, // 列表当前行的信息
    };
  },
  components: {
    CertifiedHosp: () => import("./components/page.vue"),
    TheApproved: () => import("./components/examine.vue"),
    // TheEditor: () => import("./components/details.vue"),
    // Encryption: () => import("./components/Protect.vue"),
    // testsope: () => import("./components/testcope.vue"),
    // DecryTable: () => import("./components/encryption/decryTable.vue"),
    // ModifyThe: () => import("../../layout/components/userCenter/index.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "CertifiedHosp";
        case 1:
          return "TheApproved";
        // case 2:
        //   return "TheEditor";
        // case 4:
        //   return "testsope";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      if (index == "0" && this.isActive == "1") {
        this.$children[0].Buriedpoint({
          code: "PersonalCenter:Alerts:detail",
          parent_code: "PersonalCenter:Alerts",
        });
      }
      this.isActive = index;
    },
  },
};
</script>